import { render, staticRenderFns } from "./nognyeSuccess.vue?vue&type=template&id=bf76beda&scoped=true&"
import script from "./nognyeSuccess.vue?vue&type=script&lang=js&"
export * from "./nognyeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./nognyeSuccess.vue?vue&type=style&index=0&id=bf76beda&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf76beda",
  null
  
)

export default component.exports